export default __webpack_public_path__ + "static/media/4444.82037c71.png";